// extracted by mini-css-extract-plugin
export default {"switcher":"Switcher_switcher__0NEyx","switcher__button":"Switcher_switcher__button__R9n0j","switcher__button_active":"Switcher_switcher__button_active__256en"};